import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AttrIndexService } from './attr-index.service';

@Injectable({
  providedIn: 'root'
})
export class InterlayerCardService {

	// subjectCards: any[] = [];
	// refCards: any[] = [];

	currentSbjCardBS: BehaviorSubject<{
		id;
		source?: 'card'
	}> = new BehaviorSubject({
		id: null
	});
	currentRefCardBS: BehaviorSubject<{
		id;
		source?: 'card'
	}> = new BehaviorSubject({
		id: null
	});
	sbjCardSelectionListBS: BehaviorSubject<{ids: any[]}> = new BehaviorSubject({
		ids: []
	});
	refCardSelectionListBS: BehaviorSubject<{ids: any[]}> = new BehaviorSubject({
		ids: []
	});
	sbjEditedListBS: BehaviorSubject<{ids: any[]}> = new BehaviorSubject({
		ids: []
	});
	refEditedListBS: BehaviorSubject<{ids: any[]}> = new BehaviorSubject({
		ids: []
	});

	sbjPrefix: string;
	refPrefix: string;
	constructor(
		private attrIndexService: AttrIndexService
	) { }

	getOriginalDataId(rec, prefix: string) {
		return rec[`${prefix}_${this.attrIndexService.globalIdColLower}`]
	}
	findCardIdx(rec, cardList: any[], prefix) {
		return cardList.findIndex(i => this.getOriginalDataId(i, prefix) === this.getOriginalDataId(rec, prefix));
	}
}
